import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // initialize i18next + set <html lang>/<dir> before first render
import './styles/tokens.css';
import './styles/global.css';
import './styles/buttons.css';
import './styles/modal.css'; // shared .rh-modal-* shell — before any component CSS
import './styles/rtl.css'; // RTL overrides — must load last
import App from './App';
import { initSentry } from './utils/sentry';
import { captureRelayToken } from './services/safariRelayAuth';

// Relay capture first: it strips the sign-in token from the URL before
// Sentry (or anything else) can record it.
captureRelayToken();
initSentry();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
